import { useState } from 'react'; 
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersUpdateType4 } from '../../../adminSlice';

const InputFormsForAnswersType4  = (props) => {

        const [userInputContentCompare, setUserInputContentCompare] = useState('');
        const [userInputContentSource, setUserInputContentSource] = useState('');
            

    const { dispatch } = props;
  
 // CLICK OK
const onSend = () =>  {
        

        const item = {
            content_compare: userInputContentCompare,
            
             content_source: userInputContentSource,

             answer_id: props.adminState.selectedId,
            //quiz_id: props.adminState.selectedQuize
            
        }
        dispatch(idAnswersUpdateType4(item));  
}
// ENTER INPUT
const handleUserInputContentCompare = (e) => {

            setUserInputContentCompare(e.target.value);

}
const handleUserInputContentSource = (e) => {

            setUserInputContentSource(e.target.value);

}


// CLOSE FORM
const onClose = () => {
   
    dispatch(closeInputForms());

}

        return(
            <div className="InputFormsForQuizes">
                <p >Изменить ответ:</p>
                <p className="p-text">id: {props.adminState.selectedId}</p>
                <p className="p-text">Старый ответ: {props.adminState.dataAnswersId.map(item => {
               //console.log(this.props.adminState.selectedId)
                if (item.id === Number(props.adminState.selectedId))
                //{ console.log(item.text)}
                {return item.text;} else return null;
                })}
                </p>



             
             <form>
                  <label>
                     Текст бокса/утверждение</label>
                 <textarea  onChange={handleUserInputContentCompare} 
                 ></textarea>
                <label>
                     Текст бокса/сопоставление</label>
                 <textarea  onChange={handleUserInputContentSource} 
                 ></textarea>
                 

                

             </form>
             <button onClick={onSend}>OK</button>
             <button onClick={onClose}>Закрыть</button>
            </div>
        )
      
    
}
export default InputFormsForAnswersType4;